import React, { useLayoutEffect, useRef } from "react"

import {
    css,
    FieldLabel,
    GridCell,
    Textarea,
    TextInput,
    Theme,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"

import { TEXT_WITH_ELEMENTS_TYPE } from "shape-entities/types/shape";
import calcBackgroundSize from "shape-edit/helpers/calcBackgroundSize";
import { DO_NOT_SAVE_HISTORY } from "template-edit/sagas/undoRedoHistory";

const preparedTexts = [
    'get_now',
    'discount',
    'buy_one_get_one_free',
    'free_gift',
    'add_to_cart',
    'sale',
    'buy_now',
    'buy',
    'order_now',
    'free_delivery',
    'newie',
    'in_stock'
];


const TextContentForm = ({ formName, shape, activeShapeId, change, updateShapeSizeDebounced, setEditMode }) => {
    const subFormName = `shapes.${activeShapeId}`
    const fieldName = `${formName}.${subFormName}.text_content`

    const updateShapeSize = (value) => {
        try {
            //new layer size while typing...
            const newSize = calcBackgroundSize(shape, value)
            change(formName, `${subFormName}.width`, newSize.width, DO_NOT_SAVE_HISTORY)
            change(formName, `${subFormName}.height`, newSize.height, DO_NOT_SAVE_HISTORY)
        } catch (error) {
            console.error('cannot change background size while typing', error)
        }
    }

    // updateShapeSize can flip shape.text_wrap while the user is typing (on overflow), which swaps
    // the rendered element between Textarea and TextInput. Snapshot the caret before React commits
    // that swap (render happens before the old element is removed from the DOM) so it can be restored
    // on the newly mounted element below.
    const caretSnapshotRef = useRef(null)
    const fieldEl = document.getElementById(fieldName) as HTMLInputElement | HTMLTextAreaElement | null
    if (fieldEl && document.activeElement === fieldEl) {
        caretSnapshotRef.current = { start: fieldEl.selectionStart, end: fieldEl.selectionEnd }
    }

    useLayoutEffect(() => {
        const caret = caretSnapshotRef.current
        if (!caret) {
            return
        }

        const el = document.getElementById(fieldName) as HTMLInputElement | HTMLTextAreaElement | null
        if (!el || el === document.activeElement) {
            return
        }

        el.focus()
        if (typeof el.setSelectionRange === 'function') {
            const length = el.value ? el.value.length : 0
            el.setSelectionRange(Math.min(caret.start, length), Math.min(caret.end, length))
        }
    }, [shape.text_wrap])

    return (
        <React.Fragment>
            <GridCell title={trans("text")} onClick={() => {
                const el = document.getElementById('prepared-text-content')
                el.style.display = 'block'
            }}>
                {shape.text_wrap ?
                    <Textarea
                        name={fieldName}
                        key={`text_${activeShapeId}`}
                        onChange={updateShapeSize}
                        onClick={(e) => {
                            //const cursorPosition = e.target.selectionStart
                            //console.debug(`textarea position ${cursorPosition}`)
                            setEditMode('text')
                        }}
                    /> :
                    <TextInput name={fieldName} onChange={updateShapeSize} />
                }
            </GridCell>

            <GridCell>
                <StyledDiv id={`prepared-text-content`}>
                    {preparedTexts.map(text => {
                        const translated = trans(text)

                        return <span
                            key={text}
                            onClick={() => {
                                const textContent = shape.type === TEXT_WITH_ELEMENTS_TYPE ? `${translated.toUpperCase()} %ITEM_ID%` : translated.toUpperCase()
                                change(formName, `shapes.${activeShapeId}.text_content`, textContent)
                                updateShapeSizeDebounced(subFormName, activeShapeId, true)
                            }}> <span className={'framed'} title={`${trans('prepared_text')} ${translated}`}>{trans(text)}</span>
                        </span>
                    })
                    }
                </StyledDiv>
            </GridCell>
        </React.Fragment>
    )
}

const StyledDiv = css('div')({
    display: 'none',
    ' .framed': {
        cursor: 'pointer',
        display: 'inline-block',
    },
})

export default TextContentForm